import { render, staticRenderFns } from "./ModalMessageSearchDropdown.vue?vue&type=template&id=64779bf2"
import script from "./ModalMessageSearchDropdown.vue?vue&type=script&lang=js"
export * from "./ModalMessageSearchDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports